// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {

	SETTING_CREATE_COUPON_CATEGORY,
	SETTING_CREATE_COUPON_CATEGORY_SUCCESS,
	SETTING_UPDATE_COUPON_CATEGORY,
	SETTING_UPDATE_COUPON_CATEGORY_SUCCESS,
	SETTING_LOAD_COUPON_CATEGORY,
	SETTING_LOAD_COUPON_CATEGORY_SUCCESS,
	SETTING_DELETE_COUPON_CATEGORY,
	SETTING_DELETE_COUPON_CATEGORY_SUCCESS,

	LOGOUT_USER,
	SETTING_LOAD_COUPON,
	SETTING_LOAD_COUPON_SUCCESS,
	SETTING_CREATE_COUPON,
	SETTING_CREATE_COUPON_SUCCESS,
	SETTING_UPDATE_COUPON,
	SETTING_UPDATE_COUPON_SUCCESS,
	SETTING_DELETE_COUPON,
	SETTING_DELETE_COUPON_SUCCESS,
	// SETTING_UPDATE_COUPON_STATUS,
	// SETTING_UPDATE_COUPON_STATUS_SUCCESS,

} from '../../actions';

const INIT_STATE = {

	couponCategoryLoading: false,
	couponLoading: false,
	couponCategory: [],
	optionCouponCategory: [],
	coupon: [],
	optionCoupon: [],
	// dataCompanyInformation: null,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case SETTING_LOAD_COUPON_CATEGORY:
			return { ...state, couponCategoryLoading: true, }
		case SETTING_LOAD_COUPON_CATEGORY_SUCCESS:
			return {
				...state,
				couponCategoryLoading: false,
				couponCategory: action.payload,
				optionCouponCategory: action.payloadlist
			}
		case SETTING_CREATE_COUPON_CATEGORY:
			return { ...state, couponCategoryLoading: true }
		case SETTING_CREATE_COUPON_CATEGORY_SUCCESS:
			return { ...state, couponCategoryLoading: false }
		case SETTING_UPDATE_COUPON_CATEGORY:
			return { ...state, couponCategoryLoading: true }
		case SETTING_UPDATE_COUPON_CATEGORY_SUCCESS:
			return { ...state, couponCategoryLoading: false }
		case SETTING_DELETE_COUPON_CATEGORY:
			return { ...state, couponCategoryLoading: true }
		case SETTING_DELETE_COUPON_CATEGORY_SUCCESS:
			return { ...state, couponCategoryLoading: false }
		case SETTING_LOAD_COUPON:
			return { ...state, couponLoading: true, }
		case SETTING_LOAD_COUPON_SUCCESS:
			return {
				...state,
				couponLoading: false,
				coupon: action.payload,
				optionCoupon: action.payloadlist
			}
		case SETTING_CREATE_COUPON:
			return { ...state, couponLoading: true }
		case SETTING_CREATE_COUPON_SUCCESS:
			return { ...state, couponLoading: false }
		case SETTING_UPDATE_COUPON:
			return { ...state, couponLoading: true }
		case SETTING_UPDATE_COUPON_SUCCESS:
			return { ...state, couponLoading: false }
		case SETTING_DELETE_COUPON:
			return { ...state, couponLoading: true }
		case SETTING_DELETE_COUPON_SUCCESS:
			return { ...state, couponLoading: false }
		// case SETTING_UPDATE_COUPON_STATUS:
		// 	return { ...state, couponLoading: true }
		// case SETTING_UPDATE_COUPON_STATUS_SUCCESS:
		// 	return { ...state, couponLoading: false }
		case LOGOUT_USER:
			return {
				...state,
				couponCategoryLoading: false,
				couponLoading: false,
				couponCategory: [],
				optionCouponCategory: [],
				coupon: [],
				optionCoupon: [],
			};

		default: return { ...state };
	}
}